// extracted by mini-css-extract-plugin
module.exports = {"root":"Confirmation_root__3gomr","title":"Confirmation_title__fyEqd","text":"Confirmation_text__1L9EP","btn":"Confirmation_btn___yGv5"};